export enum ActivationMethodsEnum {
  AUTOMATIC = 'automatic',
  BY_PLAYER = 'by_player',
}
